import { render, staticRenderFns } from "./feePlansAssignment.vue?vue&type=template&id=f563c828"
import script from "./feePlansAssignment.vue?vue&type=script&lang=js"
export * from "./feePlansAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports